module.exports = __webpack_public_path__ + "media/images/element/08-9b36ac7c7933eccb5e6b479c5fe0f789.svg";